module.exports = __webpack_public_path__ + "img/schema_verticalisateur_2b.c4a3ee01.svg";